/* global document */

import closeModal from './close-modal';

export default function(rootElement) {
  const closes = document.querySelectorAll('[data-role="modal-close"]');
  const messageArea = rootElement.querySelector('[data-role="modal-message"]');

  closes.forEach(close => {
    close.addEventListener('click', () => {
      closeModal(rootElement);
    }, false);
  });

  rootElement.addEventListener('click', e => {
    if (!messageArea.contains(e.target)) {
      closeModal(rootElement);
    }
  });
}
